import { DataTable, List, ListProps } from "@/components/admin"
import { FullNameField } from "@/modules/users/components/FullNameField"
const FList: React.FC<ListProps> = ({ children, sort }) => {
  return (
    <List
      sort={sort || { field: "created_at", order: "DESC" }}
      perPage={50}
      actions={false}
    >
      <DataTable bulkActionButtons={false}>
        <DataTable.Col>
          <FullNameField />
        </DataTable.Col>
        {children}
      </DataTable>
    </List>
  )
}

export default FList
